import Api from "utils/api/Api";

export const storeMeeting = (data)=>Api.post('/api/meeting/store', data);